import request from "project-config/services/request/request";

export const API = {
  checkDelete: () => {
    return request.post("/api/rendering/user/checkDelete", {});
  },
  sendPhoneCode: (phone?: string) => {
    return request.post("/api/rendering/user/validate/sendDeleteCode", {
      phone,
      type: 1,
    });
  },
  sendEmailCode: (email?: string, userName?: string) => {
    return request.post("/api/rendering/user/sendEmailCode", {
      email: email?.toLowerCase(),
      userName,
      business: 10,
    });
  },
  checkDeleteCode: (phone?: string, verificationCode?: string) => {
    return request.post("/api/rendering/user/validate/checkDeleteCode", {
      phone,
      verificationCode,
    });
  },
  validateCode: (email?: string, code?: string) => {
    return request.post("/api/rendering/user/validate/validateCode", {
      email,
      code,
    });
  },
  deleteUser: (reason?: string) => {
    return request.post("/api/rendering/user/deleteUser", {
      reason,
    });
  },
};
